var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGetFeedbackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Get Feedback"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 5110",
    d: "M4.76542 8.00085V16.0008C4.77296 16.2582 4.67812 16.508 4.50171 16.6954C4.32529 16.8829 4.08172 16.9927 3.82442 17.0008H1.94142C1.68412 16.9927 1.44054 16.8829 1.26413 16.6954C1.08771 16.508 0.992875 16.2582 1.00042 16.0008V9.00085C0.992875 8.74353 1.08771 8.49373 1.26413 8.30626C1.44054 8.11878 1.68412 8.00895 1.94142 8.00085H4.76542ZM4.76542 8.00085C5.79479 7.96871 6.76936 7.52947 7.47522 6.77955C8.18109 6.02962 8.56059 5.03028 8.53042 4.00085V3.00085C8.51475 2.74398 8.55181 2.48662 8.63933 2.24461C8.72685 2.0026 8.86297 1.78107 9.03931 1.59364C9.21565 1.40621 9.42849 1.25685 9.66472 1.15476C9.90095 1.05267 10.1556 1 10.4129 1C10.6703 1 10.9249 1.05267 11.1611 1.15476C11.3973 1.25685 11.6102 1.40621 11.7865 1.59364C11.9629 1.78107 12.099 2.0026 12.1865 2.24461C12.274 2.48662 12.3111 2.74398 12.2954 3.00085V8.00085H15.1194C15.6338 8.01731 16.1207 8.23709 16.4734 8.61201C16.826 8.98693 17.0155 9.48638 17.0004 10.0008L16.0594 15.0008C15.7814 16.2608 15.0144 17.0768 14.1774 17.0008H7.58842C6.81635 16.9768 6.08536 16.6474 5.5559 16.085C5.02645 15.5225 4.74179 14.773 4.76442 14.0008",
    stroke: "#0B1B4E",
    strokeLinecap: "square"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetFeedbackIcon);
export default __webpack_public_path__ + "static/media/Get-Feedback-icon.de5bab34befbe2d6ce77d6abac2fdac7.svg";
export { ForwardRef as ReactComponent };